import React, { useState, useEffect } from "react";
import { object, array, string } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Organism1 from "./Organism1";
import Organism2 from "./Organism2";
import WideStoryCard from "../../molecules/WideStoryCard";
import CollectionTitleWithArrow from "../../atoms/CollectionTitleWithArrow";
import CustomStoryCard4 from "../../molecules/CustomStoryCard4";
import { getSlug, getCollectionName } from "../../utils/utils";
import DfpAd from "../../dfp-ad";
import Headline from "../../atoms/Headline";
import { Link } from "@quintype/components";

import "./fourCollection12Stories1Ad.m.css";

const FourCollection12Stories1Ad = ({
  collection,
  sections,
  publisherAttributes,
  domainSlug,
  mostCommentedStories,
}) => {
  const [isTab, setIsTab] = useState(false);
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");
  const adSlotId = get(collection, ["associated-metadata", "ad_slot_id"], "default_ad_slot");

  const collectionSlug = getSlug(collection, sections, domainSlug, navigateTo);
  const collectionName = getCollectionName(collection, navigateToTitle);

  const storiesToLoadInFirstCollection = 6;

  const storiesToLoadInRemainingCollections = get(
    collection,
    ["associated-metadata", "number_of_stories_inside_collection_to_show"],
    5
  );

  const subCollections = collection.items
    .filter((collectionObj) => collectionObj.type === "collection" && collectionObj.items && collectionObj.items.length)
    .slice(0, 4);

  const columnCollections = subCollections.slice(1, 4);
  const fourthCollection = subCollections.length > 0 ? subCollections[0] : null;
  const storyList =
    fourthCollection && fourthCollection.items && fourthCollection.items.length > 0
      ? fourthCollection.items.filter((item) => item.type === "story").slice(0, storiesToLoadInFirstCollection)
      : null;

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], null);
  const showSubCollectionName = get(fourthCollection, ["associated-metadata", "show_collection_name_website"], null);

  const fourthCollectionNavigateTo = get(fourthCollection, ["associated-metadata", "navigate_to"], "");
  const fourthCollectionNavigateToTitle = get(fourthCollection, ["associated-metadata", "navigate_to_title"], "");

  const fourthCollectionName = getCollectionName(fourthCollection, fourthCollectionNavigateToTitle);
  const fourthCollectionSlug = getSlug(fourthCollection, sections, domainSlug, fourthCollectionNavigateTo);

  const mostCommentedData = get(mostCommentedStories, ["pages", "data"], null);
  const mostCommentedStoriesList =
    mostCommentedData &&
    mostCommentedData.length > 0 &&
    mostCommentedData.filter((item) => item.attributes.comments_count > 0);

  const mostCommentedStoryObjects =
    mostCommentedStoriesList &&
    mostCommentedStoriesList.length > 0 &&
    mostCommentedStoriesList
      .map((item) => ({
        story: {
          headline: item.attributes.headline,
          "hero-image-s3-key": item.attributes.hero_image_url,
          url: item.attributes.url,
        },
      }))
      .filter(({ story }) => story.headline && story.headline);

  const mostCommentedTitle = get(collection, ["associated-metadata", "most_commented_title"], "");
  const mostCommentedPosition = get(collection, ["associated-metadata", "most_commented_position"], null);

  if (!storyList) {
    return null;
  }

  useEffect(() => {
    if (global.deviceWidth > 875 && global.deviceWidth < 1264) {
      setIsTab(!isTab);
    }
  }, []);

  const getStories = (initialSliceCount, endSliceCount) => {
    if (mostCommentedPosition === 1 && mostCommentedStoryObjects.length > initialSliceCount) {
      return mostCommentedStoryObjects.slice(initialSliceCount, endSliceCount);
    } else if (mostCommentedStoryObjects !== 1 && storyList.length > initialSliceCount) {
      return storyList.slice(initialSliceCount, endSliceCount);
    } else return null;
  };

  return (
    <div styleName="base" className="four-collection-12stories-1ad" data-testid="12-stories">
      {showCollectionName && (
        <CollectionTitleWithArrow
          collectionSlug={collectionSlug}
          collectionName={collectionName}
          headlineClassName="collection-name-arrow"
          updatedFont={true}
        />
      )}
      <div styleName={columnCollections.length > 0 ? "collection-container" : ""}>
        {columnCollections && columnCollections.length > 0 && (
          <Organism1
            subCollections={columnCollections}
            publisherAttributes={publisherAttributes}
            mostCommentedStoriesList={mostCommentedStoryObjects}
            mostCommentedTitle={mostCommentedTitle}
            mostCommentedPosition={mostCommentedPosition}
            storiesToLoadInRemainingCollections={storiesToLoadInRemainingCollections}
          />
        )}
        <div className="collection-wrapper">
          {showSubCollectionName &&
            (mostCommentedPosition !== 1 ? (
              <Link href={fourthCollectionSlug}>
                <Headline
                  text={fourthCollectionName}
                  headlineType={21}
                  headerLevel={2}
                  className={`first-collection-name ${publisherAttributes.lang}-first-collection-name`}
                />
              </Link>
            ) : (
              <Headline
                text={mostCommentedTitle}
                headlineType={21}
                headerLevel={2}
                className={`first-collection-name ${publisherAttributes.lang}-first-collection-name`}
              />
            ))}
          <div styleName="collection-story-wrapper">
            <div>
              <div styleName="big-story" className="big-story-cards">
                {getStories(0, 1) && (
                  <WideStoryCard
                    story={getStories(0, 1)[0].story}
                    widths={global.deviceWidth < 876 ? [350] : [620]}
                    updatedFont={true}
                    src="four-collection-12-stories-1-ad"
                    isCommentedStory={mostCommentedPosition === 1}
                  />
                )}
              </div>
              {getStories(1, 3) && (
                <div styleName="medium-story" className="medium-story-cards">
                  <Organism2
                    storyList={getStories(1, 3)}
                    updatedFont={true}
                    publisherLang={publisherAttributes.lang}
                    isCommentedStory={mostCommentedPosition === 1}
                  />
                </div>
              )}
            </div>
            <div>
              <div styleName={isTab ? "ad-slot-728x90" : "ad-slot-300x250"}>
                <DfpAd
                  adtype={publisherAttributes.lang === "en" ? "EnPalo_HP_336x280_R2" : "Home_336x280_R2"}
                  collectionSlug={collectionSlug}
                  layoutName="FourCollection12Stories1Ad"
                  slotId={adSlotId}
                />
              </div>
              {getStories(3, 6) && (
                <div styleName={isTab ? "tab-small-story" : "small-story"} className="small-story-cards">
                  {getStories(3, 6).map(({ story }, index) => (
                    <CustomStoryCard4
                      story={story}
                      headlineType={16}
                      showStoryMetaInfo={false}
                      key={index}
                      updatedFont={true}
                      src="four-collection-12-stories-1-ad"
                      isCommentedStory={mostCommentedPosition === 1}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FourCollection12Stories1Ad.propTypes = {
  collection: object,
  sections: array,
  publisherAttributes: object,
  domainSlug: string,
  mostCommentedStories: object,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps, null)(FourCollection12Stories1Ad);
